import { observer } from 'mobx-react-lite';
import { WecomLogin } from './wecomLogin';
import { NormalLogin } from './normalLogin';
import { DingtalkLogin } from './dingtalkLogin';
import { FeishuLogin } from './feishuLogin';
import type { FormProps } from './types';
import type { ReactElement } from 'react';

function FormComponent({ store }: FormProps): ReactElement {
  if (store.isPasswordLogin) {
    return <NormalLogin store={store} />;
  }

  if (store.isDingtalkLogin) {
    return <DingtalkLogin store={store} />;
  }

  if (store.isFeishuLogin) {
    return <FeishuLogin store={store} />;
  }

  return <WecomLogin store={store} />;
}

export const Form = observer(FormComponent);
